<template>
    <div :style="getStyle" class="round-button-container">
        <div class="left-round"></div>

        <div class="content">
            <slot />
        </div>
        <div class="right-round"></div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ValidateRecordButton",
    props: {
        text: String,
        background: {
            type: String,
            required: false,
            default: "transparent"
        },
        textColor: {
            type: String,
            required: false,
            default: "inherit"
        },
        height: {
            type: String,
            required: false,
            default: "48px"
        }
    },
    computed: {
        getStyle() {
            return {
                "--background": this.background,
                "--height": this.height,
                "--color": this.textColor
            };
        }
    }
});
</script>

<style scoped>
.round-button-container {
    display: flex;
    flex-direction: row;
    background-color: transparent;
    align-items: center;
    justify-content: center;
    height: var(--height);
}

.content {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: var(--background);
    color: var(--color);
    height: 100%;
    flex-grow: 1;
}

.left-round {
    height: var(--height);
    width: var(--height);
    border-top-left-radius: 50% 50%;
    border-bottom-left-radius: 50% 50%;
    transform: translateX(50%);
    background: linear-gradient(
        to left,
        transparent,
        transparent 49%,
        var(--background) 49%,
        var(--background)
    );
}

.right-round {
    height: var(--height);
    width: var(--height);
    border-top-right-radius: 50% 50%;
    border-bottom-right-radius: 50% 50%;
    transform: translateX(-50%);
    background: linear-gradient(
        to right,
        transparent,
        transparent 49%,
        var(--background) 49%,
        var(--background)
    );
}
</style>
